<span class="snackbar-wrapper">
    <div [class]="snackbarContentClass">
        <lib-app-icon [icon]="getIcon(data.type)" size="24x24" [class]="snackbarIconClass" />
        <span [class]="snackbarTextClass">{{data.message}}</span>
        <!-- <button [class]="snackbarActionClass" (click)="onActionClick()">{{data.action}}</button> -->
    </div>
    @if(this.data.persistent) {
        <button [cdkCopyToClipboard]="data.message" [class]="getCopyButtonClass()" i18n>Copy error</button>
    }
    <button (click)="onClose()">
        <mat-icon class="cursor-pointer" [class]="snackbarCloseIconClass">close</mat-icon>
    </button> 
</span>